import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import styles from './home.module.scss';
import { RootState } from '../../../shared/redux/reducers';
import { trackPage } from '../../../shared/services/utils/tracking/tracking.service';
import { ReservationsUpdates } from './components/reservations-updates/reservations-updates.component';
import { withAuthorization } from '../../../shared/services/auth/with-authorization/with-authorization.component';
import { UserRole } from '../../../shared/enums/user-role.enum';

import _ from 'lodash';
import GlobalCalendarComponent from './components/global-calendar/global-calendar.component';

/**
 * functional component HomeContainer
 * @param {HomeContainerProps} holding question text
 */
export const HomeContainer = () => {
  const { t } = useTranslation();

  useEffect(() => {
    trackPage('dashboard');

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className={styles['home-container']}>
        <div className={styles['home-container__title']}>{t('DASHBOARD_MODULE.HOME.TITLE')}</div>
        <ReservationsSummary />
      </div>
      <div className={styles['home-container']}>
        <div className={styles['home-container__title']}>Calendar</div>
        <CalendarComponent />
      </div>
    </>
  );
};

export default connect()(HomeContainer);

const ReservationsSummary = withAuthorization(
  [UserRole.ADMIN, UserRole.PARTNER_MANAGER, UserRole.SUPER_ADMIN, UserRole.LANDLORD],
  true
)(() => <ReservationsUpdates />);

const CalendarComponent = withAuthorization(
  [UserRole.ADMIN, UserRole.PARTNER_MANAGER, UserRole.SUPER_ADMIN, UserRole.LANDLORD],
  true
)(() => <GlobalCalendarComponent />);
